import { render, staticRenderFns } from "./Term.vue?vue&type=template&id=5d464e37&"
import script from "./Term.vue?vue&type=script&lang=js&"
export * from "./Term.vue?vue&type=script&lang=js&"
import style0 from "./Term.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports